import tools from '../../tools';
import ToolbarGroup from './ToolbarGroup';

/*
 * CAUTION: Do not be tempted to parameterize this code so that some tools
 * are shown or hidden based on a prop. That should be a concern of the
 * application and not this library. If the application wants to customize
 * the toolbar or menu it should create its own version.
 */

// Standard menu for inserting new elements into a document.
const ToolbarInsertMenu = () =>
  ToolbarGroup({
    menu: {
      icon: 'fa-regular fa-plus',
      name: 'More',
      tools: [
        [
          tools.ToolInsertLink,
          tools.ToolInsertLinkCard,
          tools.ToolInsertMedia,
          tools.ToolInsertEmbed,
          tools.ToolAddSnippet,
          tools.ToolInsertInfoBlock,
          tools.ToolInsertTable,
          tools.ToolInsertLabelPill,
          tools.ToolInsertDividerLine,
          tools.ToolToggleTableOfContents,
          tools.ToolWordCount,
        ],
        [tools.ToolCopyFormat, tools.ToolPasteFormat],
      ],
    },
  });

export default ToolbarInsertMenu;
